export default "__VITE_ASSET__BD57J1uH__"